export default __webpack_public_path__ + "assets/images/f2932c8376e5ceb919551a4af13a03e7.png";